module.exports = __webpack_public_path__ + "img/store.e432215d.svg";